var React = require('react');

function StarIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m5.39351 15.9912c-.30877.1423-.65939.165-.98392.0636s-.59985-.3197-.77262-.6126c-.12831-.259-.17154-.552-.12351-.8371l.75477-4.0208-2.95044-2.82692c-.22758-.25216-.353557-.57976-.353557-.91944 0-.33967.125977-.66728.353557-.91944.20478-.20445.46896-.33894.75477-.38424l4.11688-.59009 1.8526-3.69147c.16582-.296753.43588-.521394.75786-.630411s.67296-.094651.98495.040319c.25315.13067.45945.336905.59005.590092l1.8389 3.69147 4.1169.59009c.3344.06336.6333.24869.8387.52003s.3026.60932.2729.94833c-.0422.28979-.1827.55628-.398.75476l-2.9504 2.82692.6998 4.0208c.0431.336-.0395.6761-.2321.9547-.1925.2787-.4813.4763-.8108.5549-.2851.048-.578.0048-.8371-.1235l-3.69148-1.9213z"}));
}

StarIcon.defaultProps = {"height":"17","viewBox":"0 0 18 17","width":"18"};

module.exports = StarIcon;

StarIcon.default = StarIcon;
